(function () {
  'use strict';

  angular
    .module('component.delete-cart-item', [])

    .component('buttonDeleteCartItem', {
      bindings: {
        id: '<idProduct',
        btnClass: '@',
        productQuantity: '<',
        designation: '@productDesignation',
        img: '<productImg',
        titleBtn: '@?',
        titleResultOk: '@?'
      },
      templateUrl: 'component.delete-cart-item.tpl',
      /* @ngInject */
      controller: ["$rootScope", "ModalService", "AppService", "toastr", function ($rootScope, ModalService, AppService, toastr) {
        var ctrl = this;

        ctrl.delete = function () {
          ModalService.show(
            '/Template/Cart/ModalDeleteConfirm',
            {
              action: function () {
                deleteItem();
              }
            },
            null,
            'deleteConfirmModalCtrl'
          );
        };

        // Functions

        function deleteItem() {
          $rootScope.$broadcast('showPageLoader', true);

          var products = [{
            idProduct: ctrl.id,
            quantity: ctrl.productQuantity * -1,
            img: ctrl.img
          }];

          AppService.addToCart(products)
            .then(function (response) {
              if (response.status === 'OK') {
                AppService.updateParams(response.results);
                toastr.success(ctrl.designation, ctrl.titleResultOk, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_addtocart.tpl',
                    data: {
                      img: products[0].img
                    }
                  }
                });
              } else {
                AppService.getTranslate()
                  .then(function (translate) {
                    toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                      allowHtml: true,
                      extraData: {
                        template: 'toast_message.tpl'
                      }
                    });
                  })
                  .catch(function (error) {
                    console.error(error);
                  });
              }
              $rootScope.$broadcast('showPageLoader', false);
            })
            .catch(function (error) {
              console.error(error);
            });
        }

      }]
    });

})();
